<template>
  <v-snackbar
    v-model="isSnackbar"
    :color="multipleColor"
    :timeout="-1"
    :max-width="10000"
  >
    <div
      v-for="(item, index) in messages"
      :key="`message_${index}`"
    >
      {{ item }}
    </div>
    <template v-slot:action="{ attrs }">
      <v-btn
        text
        v-bind="attrs"
        @click="hideSnackbar"
      >
        閉じる
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>

import { mapState, mapActions } from 'vuex'

/**
 * example
 * <snackbar />
 */
export default {
  name: 'MultiSnackbarComponent',
  data () {
    return {
      timeout: 10000,
      isSnackbar: false,
      messages: [],
    }
  },
  computed: {
    ...mapState('snackbar', {
      enableMultiple: "showMultiple",
      multipleMessage: 'multipleMessage',
      multipleColor: 'multipleColor'
    }),
  },
  watch: {
    enableMultiple (newVal) {
      this.isSnackbar = newVal
      const $self = this;
      setTimeout(()=>{
        $self.multiHide();
      },this.timeout);
    },
    multipleMessage (newVal) {
      if (Array.isArray(newVal)) {
        this.messages = newVal
      } else {
        this.messages = (newVal === null) ? [] : newVal.split(',')
      }
    },
  },
  methods: {
    ...mapActions('snackbar', {
      multiHide: 'multiHide'
    }),
    hideSnackbar () {
      this.multiHide()
    }
  }
}

</script>

<style scoped lang="scss">
</style>
